"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tiles = function (_Component) {
  (0, _inherits3.default)(Tiles, _Component);

  function Tiles(props) {
    (0, _classCallCheck3.default)(this, Tiles);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Tiles.__proto__ || (0, _getPrototypeOf2.default)(Tiles)).call(this, props));

    _this.state = {
      visibleItemLength: 4
    };
    return _this;
  }

  (0, _createClass3.default)(Tiles, [{
    key: "showMore",
    value: function showMore(e) {
      e.preventDefault();
      if (this.props.items.length > this.state.visibleItemLength) {
        this.setState({ visibleItemLength: this.state.visibleItemLength + 4 });
      } else {
        this.setState({ visibleItemLength: 4 });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          showMore = _props.showMore,
          showLess = _props.showLess,
          items = _props.items,
          openLinkInNewTab = _props.openLinkInNewTab;

      // TODO: confirm CSS style and layout

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "heading" },
          _react2.default.createElement(
            "h2",
            { className: "title" },
            title
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content" },
          items.filter(function (item, index) {
            return index < _this2.state.visibleItemLength;
          }).map(function (item, index) {
            return _react2.default.createElement(
              "div",
              { className: "campaign-box", key: index, style: { backgroundImage: "url(" + item.imageUrl + ")" } },
              _react2.default.createElement(
                "a",
                {
                  href: item.pageUrl,
                  target: openLinkInNewTab ? '_blank' : '',
                  rel: openLinkInNewTab ? 'noopener noreferrer' : ''
                },
                _react2.default.createElement(
                  "p",
                  null,
                  item.title
                )
              )
            );
          }),
          _react2.default.createElement(
            "div",
            { className: "more-link" },
            _react2.default.createElement(
              "a",
              { href: true, onClick: function onClick(e) {
                  return _this2.showMore(e);
                } },
              items.length > this.state.visibleItemLength ? showMore : showLess
            )
          )
        )
      );
    }
  }]);
  return Tiles;
}(_react.Component); // Tiles

Tiles.propTypes = {
  title: _react.PropTypes.string.isRequired,
  showMore: _react.PropTypes.string.isRequired,
  showLess: _react.PropTypes.string.isRequired,
  items: _react.PropTypes.array.isRequired,
  openLinkInNewTab: _react.PropTypes.bool
};

Tiles.defaultProps = {
  openLinkInNewTab: true
};

exports.default = Tiles;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Tiles.js
// module id = 1229
// module chunks = 0